import { createSlice, PayloadAction } from 'ngrx-slice';

import {
  OrderListItemCreateRequest,
  OrderListItemResponse,
  PageableObject,
  SortObject,
} from '@app/api/marketplace/models';
import { paginatorConfiguration } from '@shared/constants/paginator-configuration';
import { PageRequest } from '@shared/interfaces/page-request.interface';
import { PageResponse } from '@shared/interfaces/page-response.interface';

export interface State {
  // get list
  orderListFilter: PageRequest;
  orderList: PageResponse<OrderListItemResponse>;
  isLoading: boolean;
  orderListLoadError: boolean;
  // save orderList
  orderListSaving: boolean;
  orderListSaveError: boolean;
  // offerList
  offerListLoading: boolean;
  offerListLoadError: boolean;
  errorIds: Array<string>;
}

export const initialListState = {
  totalPages: 0,
  totalElements: 0,
  size: 0,
  content: [],
  number: 0,
  sort: {} as SortObject,
  pageable: {} as PageableObject,
  first: true,
  last: true,
  numberOfElements: 0,
  empty: true,
};

export const initialState: State = {
  orderListFilter: {
    page: paginatorConfiguration.defaultPageIndex,
    size: paginatorConfiguration.pageSizeOptions[0],
    sort: [],
  },
  orderList: initialListState,
  isLoading: false,
  orderListLoadError: false,
  orderListSaving: false,
  orderListSaveError: false,
  offerListLoading: false,
  offerListLoadError: false,
  errorIds: [],
};

export const {
  actions: OrderListActions,
  selectors,
  ...OrderListFeature
} = createSlice({
  name: 'order-list',
  initialState,
  reducers: {
    loadOrderList: {
      trigger: (state, action: PayloadAction<{ filter: PageRequest }>) => {
        state.orderListFilter = action.filter;
        state.isLoading = true;
      },
      success: (
        state,
        action: PayloadAction<{
          response: PageResponse<OrderListItemResponse>;
        }>
      ) => {
        state.orderList = action.response;
        state.isLoading = false;
        state.orderListLoadError = false;
      },
      failure: (state) => ({
        ...state,
        orderListLoadError: true,
        isLoading: false,
      }),
    },
    updateItem: {
      trigger: (
        _state,
        action: PayloadAction<{ itemId: string; amount: number }>
      ) => {},
      success: () => {},
    },
    addItems: {
      trigger: (
        _state,
        action: PayloadAction<{ request: OrderListItemCreateRequest }>
      ) => {},
      success: () => {},
      failure: (
        state,
        action: PayloadAction<{ errorIds?: Array<string> }>
      ) => ({ ...state, errorIds: action.errorIds ?? [] }),
    },
    removeItem: {
      trigger: (state_, action: PayloadAction<{ id: string }>) => {},
      success: () => {},
    },
    removeItems: {
      trigger: (
        _state,
        action: PayloadAction<{ request: Array<string> }>
      ) => {},
      success: () => {},
    },
    updateOrderListFromSearch: {
      trigger: (
        _state,
        action: PayloadAction<{
          body: {
            orderListBulk: {
              [key: string]: number;
            };
          };
        }>
      ) => {},
      success: () => {},
    },
    resetErrorIds: {
      trigger: (state) => ({ ...state, errorIds: [] }),
      success: () => {},
    },
    reset: (_) => initialState,
  },
});

export const OrderListSelectors = {
  ...selectors,
};
